import seguridadesServices from '../services/Seguridades'

const usuariosLogic = async (page, perPage, tipoUsuario, search) => {
  let dataResp = seguridadesServices.usuariosService(page, perPage, tipoUsuario, search)
  return dataResp
}

const usuariosByIdLogic = async (userId) => {
  let dataResp = seguridadesServices.usuariosByIdService(userId)
  return dataResp
}

const rolesLogic = async (page, perPage, search = "") => {
  let dataResp = seguridadesServices.rolesService(page, perPage, search)
  return dataResp
}

const usuariosLinkLogic = async (page, perPage, userType) => {
  let dataResp = seguridadesServices.usuariosLinkService(page, perPage, userType)
  return dataResp
}

const getRolesLogic = async (page, perPage, userType) => {
  let dataResp = seguridadesServices.getRolesService(page, perPage, userType)
  return dataResp
}

const saveEditRolesLogic = async (data) => {
  let dataResp = seguridadesServices.saveEditRolesServices(data)
  return dataResp
}

const rolesPhantomLogic = async (page, perPage, search = "") => {
  let dataResp = seguridadesServices.rolesPhantomService(page, perPage, search)
  return dataResp
}

const seguridadesLogic = {
  usuariosLogic,
  rolesLogic,
  usuariosByIdLogic,
  usuariosLinkLogic,
  getRolesLogic,
  saveEditRolesLogic,
  rolesPhantomLogic
}

export default seguridadesLogic
